const healthRouterMap = [
  // 火烧云健康管理在线平台
  /* {
    name: "身份选择",
    path: "/health/identityChoice",
    component: () => import("@/pages/health/identityChoice"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "火烧云健康管理在线平台",
    path: "/health/home",
    component: () => import("@/pages/health/home"),
    meta: {
      systemCode: 'huoshaoyun'
    }
  },
  {
    name: "申报登记",
    path: "/health/registration",
    component: () => import("@/pages/health/registration"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "申报登记列表",
    path: "/health/personnerecord",
    component: () => import("@/pages/health/personnerecord"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "健康记录",
    path: "/health/temperature",
    component: () => import("@/pages/health/temperature")
  },
  {
    name: "人员管理",
    path: "/health/personnellist",
    component: () => import("@/pages/health/personnellist"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "个人健康记录列表",
    path: "/health/healthrecord",
    component: () => import("@/pages/health/healthrecord"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  }, */
  // 医生
  {
    name: "申报登记列表",
    path: "/health_doctor/home",
    component: () => import("@/pages/health_doctor/home"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  //企业健康管理
  {
    name: "企业健康管理",
    path: "/health_enterprise/home",
    component: () => import("@/pages/health_enterprise/home")
  },
  {
    name: "企业申报登记",
    path: "/health_enterprise/registration",
    component: () => import("@/pages/health_enterprise/registration"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "企业",
    path: "/health_enterprise/search",
    component: () => import("@/pages/health_enterprise/search"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "人员管理",
    path: "/health_enterprise/personnellist",
    component: () => import("@/pages/health_enterprise/personnellist"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  // 上海虹口健康
  {
    name: "上海虹口健康管理在线平台",
    path: "/health_shanghai/home",
    component: () => import("@/pages/health_shanghai/home")
  },
  {
    name: "健康登记",
    path: "/health_shanghai/personnellist",
    component: () => import("@/pages/health_shanghai/personnellist"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "新增人员登记",
    path: "/health_shanghai/registration",
    component: () => import("@/pages/health_shanghai/registration"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  // 三亚健康
  {
    name: "三亚健康管理在线平台",
    path: "/health_sanya/home",
    component: () => import("@/pages/health_sanya/home")
  },
  {
    name: "健康登记",
    path: "/health_sanya/personnellist",
    component: () => import("@/pages/health_sanya/personnellist"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "申报登记列表",
    path: "/health_sanya/personnerecord",
    component: () => import("@/pages/health_sanya/personnerecord"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "新增人员登记",
    path: "/health_sanya/registration",
    component: () => import("@/pages/health_sanya/registration"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "个人健康记录列表",
    path: "/health_sanya/healthrecord",
    component: () => import("@/pages/health_sanya/healthrecord"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "健康记录",
    path: "/health_sanya/temperature",
    component: () => import("@/pages/health_sanya/temperature")
  },
  // 翔安康
  {
    name: "身份选择",
    path: "/health_xiangan/identityChoice",
    component: () => import("@/pages/health_xiangan/identityChoice")
  },
  {
    name: "火烧云健康管理在线平台",
    path: "/health_xiangan/home",
    component: () => import("@/pages/health_xiangan/home")
  },
  {
    name: "申报登记", // 返厦新增人员
    path: "/health_xiangan/registration",
    component: () => import("@/pages/health_xiangan/registration"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "申报登记列表",
    path: "/health_xiangan/personnerecord",
    component: () => import("@/pages/health_xiangan/personnerecord"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "健康记录",
    path: "/health_xiangan/temperature",
    component: () => import("@/pages/health_xiangan/temperature")
  },
  {
    name: "人员管理",
    path: "/health_xiangan/personnellist",
    component: () => import("@/pages/health_xiangan/personnellist"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "个人健康记录列表",
    path: "/health_xiangan/healthrecord",
    component: () => import("@/pages/health_xiangan/healthrecord"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  //翔安健康码
  {
    name: "首页",
    path: "/health_xiangan_code/checkpoint/home",
    component: () => import("@/pages/health_xiangan_code/checkpoint/home"),
    meta: {
      systemCode: 'xianganma'
    }
  },
  {
    name: "检查点登记",
    path: "/health_xiangan_code/checkpoint/registration",
    component: () =>
      import("@/pages/health_xiangan_code/checkpoint/registration")
  },
  {
    name: "检查点",
    path: "/health_xiangan_code/checkpoint/list",
    component: () => import("@/pages/health_xiangan_code/checkpoint/list"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "检查码",
    path: "/health_xiangan_code/checkpoint/code",
    component: () => import("@/pages/health_xiangan_code/checkpoint/code")
  },
  {
    name: "人员列表",
    path: "/health_xiangan_code/user/personnellist",
    component: () => import("@/pages/health_xiangan_code/user/personnellist"),
    meta: {
      systemCode: 'xianganma',
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "健康码",
    path: "/health_xiangan_code/user/detail",
    component: () => import("@/pages/health_xiangan_code/user/detail")
  },
  //返校,
  {
    name: "健康登记",
    path: "/health_school/registration",
    component: () => import("@/pages/health_school/registration"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "上报记录",
    path: "/health_school/healthrecord",
    component: () => import("@/pages/health_school/healthrecord"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "每日上报",
    path: "/health_school/temperature",
    component: () => import("@/pages/health_school/temperature")
  },
  {
    name: "班主任首页",
    path: "/health_school/teacher/home",
    component: () => import("@/pages/health_school/teacher/home"),
    meta: {
      systemCode: 'fanxiao',
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "创建班级",
    path: "/health_school/teacher/guide",
    component: () => import("@/pages/health_school/teacher/guide"),
    meta: {
      systemCode: 'fanxiao'
    }
  },
  {
    name: "班主任创建班级页",
    path: "/health_school/teacher/createclass",
    component: () => import("@/pages/health_school/teacher/createclass")
  },
  //学生
  {
    name: "加入班级",
    path: "/health_school/student/guide",
    component: () => import("@/pages/health_school/student/guide"),
    meta: {
      systemCode: 'fanxiao'
    }
  },
  {
    name: "学生首页",
    path: "/health_school/student/home",
    component: () => import("@/pages/health_school/student/home"),
    meta: {
      systemCode: 'fanxiao'
    }
  },
  {
    name: "我的班级",
    path: "/health_school/student/myclass",
    component: () => import("@/pages/health_school/student/myclass")
  }
];

export default healthRouterMap;
